

// CSS
// Problem with this: https://github.com/Semantic-Org/Semantic-UI-React/issues/4227
// - /Users/kgaidis/Documents/Projects/personal_website/website/node_modules/semantic-ui-css/semantic.css
// - /Users/kgaidis/Documents/Projects/personal_website/website/node_modules/semantic-ui-css/semantic.min.css
import 'semantic-ui-css/semantic.min.css';
import './index.css';

// Create React App
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';

// Third-Party
// ...

// Custom
import Home from './home/Home';
import GlobalStyle from './shared/styling/GlobalStyle';

ReactDOM.render(
  <React.StrictMode>
    <Home />
    <GlobalStyle />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
